import React from 'react'

import Storage from '../../lib/storage'
import { NavTarget } from '../../lib/static/enums'
import styles from './component.module.scss'

export const Layout = (props) => {
  const profile = Storage.getProfile();

  return (
    <div className={`header-fixed header-mobile-fixed subheader-enabled subheader-fixed aside-enabled aside-fixed aside-minimize-hoverable aside-minimize ${styles.root}`}>
      <div className={'d-flex flex-row flex-column-fluid page'}>

        <aside className={'aside aside-left aside-fixed d-flex flex-column flex-row-auto'}>
          <div className={'aside-menu-wrapper flex-column-fluid'}>

            <a href={'/'} className={styles.logo}>Metalle.Direct</a>

            <div className={'aside-menu my-4'}>
              <ul className={'menu-nav'}>
                <li className={'menu-item menu-item-active'}>
                  <button onClick={props.menuclicked} value={NavTarget.ORDERS} title={'Aufträge'} className={'btn'}>
                    <i className={'menu-icon flaticon-home'}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <path d="M22,17 L22,21 C22,22.1045695 21.1045695,23 20,23 L4,23 C2.8954305,23 2,22.1045695 2,21 L2,17 L6.27924078,17 L6.82339262,18.6324555 C7.09562072,19.4491398 7.8598984,20 8.72075922,20 L15.381966,20 C16.1395101,20 16.8320364,19.5719952 17.1708204,18.8944272 L18.118034,17 L22,17 Z" fill="#ffffff" opacity="0.5" />
                          <path d="M2.5625,15 L5.92654389,9.01947752 C6.2807805,8.38972356 6.94714834,8 7.66969497,8 L16.330305,8 C17.0528517,8 17.7192195,8.38972356 18.0734561,9.01947752 L21.4375,15 L18.118034,15 C17.3604899,15 16.6679636,15.4280048 16.3291796,16.1055728 L15.381966,18 L8.72075922,18 L8.17660738,16.3675445 C7.90437928,15.5508602 7.1401016,15 6.27924078,15 L2.5625,15 Z" fill="#ffffff" opacity="0.2" />
                          <path d="M11.1288761,0.733697713 L11.1288761,2.69017121 L9.12120481,2.69017121 C8.84506244,2.69017121 8.62120481,2.91402884 8.62120481,3.19017121 L8.62120481,4.21346991 C8.62120481,4.48961229 8.84506244,4.71346991 9.12120481,4.71346991 L11.1288761,4.71346991 L11.1288761,6.66994341 C11.1288761,6.94608579 11.3527337,7.16994341 11.6288761,7.16994341 C11.7471877,7.16994341 11.8616664,7.12798964 11.951961,7.05154023 L15.4576222,4.08341738 C15.6683723,3.90498251 15.6945689,3.58948575 15.5161341,3.37873564 C15.4982803,3.35764848 15.4787093,3.33807751 15.4576222,3.32022374 L11.951961,0.352100892 C11.7412109,0.173666017 11.4257142,0.199862688 11.2472793,0.410612793 C11.1708299,0.500907473 11.1288761,0.615386087 11.1288761,0.733697713 Z" fill="#ffffff" fillRule="nonzero" transform="translate(11.959697, 3.661508) rotate(-90.000000) translate(-11.959697, -3.661508)" opacity="0.5" />
                        </g>
                      </svg>
                    </i>
                  </button>
                </li>
                <li className={'menu-item menu-item-active'}>
                  <button onClick={props.menuclicked} title={'Banking'} value={NavTarget.BANKING} className={'btn'}>
                    <i className={'menu-icon flaticon-banking'}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24">
                        <g>
                          <g>
                            <rect height="7" width="3" x="4" y="10" fill="#ffffff" opacity="0.2" />
                            <rect height="7" width="3" x="10.5" y="10" fill="#ffffff" opacity="0.2" />
                            <rect height="3" width="20" x="2" y="19" fill="#ffffff" opacity="0.5" />
                            <rect height="7" width="3" x="17" y="10" fill="#ffffff" opacity="0.2" />
                            <polygon points="12,1 2,6 2,8 22,8 22,6" fill="#ffffff" opacity="0.5" /></g></g></svg>
                    </i>
                  </button>
                </li>
                <li className={'menu-item menu-item-active'}>
                  <button onClick={props.menuclicked} title={'Unblock Iban'} value={NavTarget.UNBLOCK} className={'btn'}>
                    <i className={'menu-icon flaticon-unblock'}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24">
                        <g
                          id="layer1">
                          <path
                            id="path94"
                            d="M 8.3854098,0.57086326 C 7.625107,0.70658998 6.9229995,1.0001592 6.278823,1.5246524 5.7534528,1.9524033 5.3241948,2.472426 4.9707255,3.1189057 3.1940748,6.3685356 4.4255957,11.00036 7.4637752,12.199542 c 0.6779263,0.267598 1.4064542,0.316237 2.1065868,0.204843 0.678097,-0.107947 1.360409,-0.407332 1.931032,-0.87928 C 14.273218,9.2327735 14.437836,3.9820449 11.633055,1.6057908 11.150558,1.19703 10.620009,0.89116155 10.053118,0.71865984 9.5207246,0.55666545 8.9314519,0.47338553 8.3854098,0.57086326 M 16.109541,14.006632 c -0.655762,0 -1.605828,-0.211794 -2.083365,0.497495 -0.411441,0.611138 -0.286539,1.497915 -0.286539,2.238112 v 5.088234 c 0,0.716843 -0.124379,1.609036 0.321647,2.170654 0.589714,0.742608 1.770275,0.455531 2.531019,0.455531 2.230602,0 4.486666,0.123923 6.714728,-0.0019 0.544332,-0.03082 1.036699,-0.467789 1.161736,-1.146823 0.120687,-0.655506 0.02322,-1.462018 0.02322,-2.133776 v -4.26755 c 0,-0.761536 0.136399,-1.70379 -0.254065,-2.350436 -0.408897,-0.677225 -1.169018,-0.549308 -1.764744,-0.549308 h -4.564259 v -3.22802 c 0,-0.739053 0.06254,-1.4800742 0.658307,-1.8604335 0.648209,-0.4138432 1.408336,-0.00914 1.678024,0.8209019 0.123891,0.3812346 0.034,0.8415286 0.344906,1.1085786 0.415215,0.356559 1.435855,0.246642 1.496637,-0.506745 C 22.352708,7.0451209 18.939517,5.5057443 17.11961,7.4654197 15.692001,9.0026135 16.109544,11.91954 16.109544,14.006865 M 12.81801,24.456891 c -0.422109,-1.265603 -0.307211,-2.586903 -0.307211,-3.939278 0,-2.130273 -0.205786,-4.410291 0.263322,-6.456034 -0.373742,-0.0039 -0.768679,-0.13213 -1.141063,-0.03334 -0.945463,0.250631 -1.7604886,0.76843 -2.7648885,0.74381 -0.9822817,-0.02415 -1.787873,-0.544705 -2.7210046,-0.747194 -1.1400531,-0.247407 -2.5436201,0.278373 -3.4670793,1.099605 -1.69368858,1.506231 -2.15047052,3.646462 -2.15047052,6.104407 0,1.020929 -0.0426603,2.101497 0.70236672,2.773856 0.8797363,0.793982 2.3532082,0.454161 3.3791352,0.454161 h 8.206893 m 6.056422,-6.711764 c 1.547726,-0.32236 2.036366,2.649991 0.482762,2.973502 -1.541143,0.320997 -2.038822,-2.649436 -0.482762,-2.973502 z"
                            style={{ fill: '#ffffff', opacity: 0.5, stroke: 'none', strokeWidth: 0.0846667 }} />
                        </g></svg>
                    </i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </aside>

        <main className={'d-flex flex-column flex-row-fluid wrapper'}>
          <div className={'header header-fixed'}>
            <div className={'container-fluid d-flex align-items-stretch justify-content-between'}>
              <div className={'header-menu-wrapper header-menu-wrapper-left'} />
              <div className={'topbar'}>
                <div className={`topbar-item ${styles.profile}`}>
                  <span className={'text-muted font-weight-bold font-size-base d-none d-md-inline mr-1'}>Hi,</span>
                  <span className={'text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3'}>
                    {profile && <>{profile.name}</>}
                    {!profile && <>PROFILNAME</>}
                  </span>
                  <span className={'symbol symbol-35 symbol-light-success'}>
                    <span className={`symbol-label font-size-h5 font-weight-bold ${styles.icon}`}>
                      {profile && <>{profile.name[0]}</>}
                      {!profile && <>?</>}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className={'content d-flex flex-column flex-column-fluid'}>
            {props.children}
          </div>
        </main>

      </div>
    </div>
  );
}

export const Content = (props) => (
  <div className={'d-flex flex-column-fluid'}>
    <div className={styles.container}>
      {props.children}
    </div>
  </div>
)

export const SubHeader = (props) => (
  <div className={'subheader py-2 py-lg-4 subheader-solid'}>
    <div className={'container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap'}>
      <div className={'d-flex align-items-center flex-wrap mr-1'}>
        <div className={'d-flex align-items-baseline mr-5'}>
          {props.title &&
            <h5 className={'text-dark font-weight-bold my-2 mr-5'}>{props.title}</h5>
          }
          {props.subtitle &&
            <p className={'my-2'}>{props.subtitle}</p>
          }
        </div>
      </div>

      {props.children}
    </div>
  </div>
);
